module.exports = __webpack_public_path__ + "img/collection-weddingRingsRedgold.51d9336.webp";